import React, {useState} from 'react';
import {Box, Button, Divider, Drawer, IconButton, Stack, Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';

import {Close} from '@icons/index';
import {Sizes} from '@constants/sizes.constants';
import {jobsInvoiceQuery} from '@store/invoices/jobsInvoice';
import AsyncMultiSelectWithSearchComponent
  from '@components/inputs/asyncMultiSelect/AsyncMultiSelectWithSearch.component';
import NumberTextFieldComponent from '@components/inputs/numberTextField/NumberTextField.component';
import {JobInvoiceDetailsFilters} from '@screens/admin/invoices/invoicesValidation/details/JobInvoiceDetails.modal';

interface FiltersDrawerProps {
  filters: JobInvoiceDetailsFilters;
  handleSave: (filters: JobInvoiceDetailsFilters) => void;
  handleClose: () => void;
}

const FiltersDrawer = (props: FiltersDrawerProps) => {
  const {filters, handleSave, handleClose} = props;

  const {t} = useTranslation();

  const [newFilters, setNewFilters] = useState<JobInvoiceDetailsFilters>(filters);

  const updateFilter = (name: string) => (value: any) => setNewFilters((state) => ({...state, [name]: value}));

  return (
    <Drawer anchor="right" open onClose={handleClose}>
      <Stack flex={1} overflow="hidden">
        <Stack mr="10px">
          <Stack>
            <Stack direction="row" alignItems="center" justifyContent="space-between" mb="12px" mr="-8px">
              <Typography fontSize={18} fontWeight="700">
                {t('global.filters')}
              </Typography>
              <IconButton onClick={handleClose}>
                <Close/>
              </IconButton>
            </Stack>
            <Divider variant="fullWidth" orientation="horizontal"/>
          </Stack>
          <Divider variant="fullWidth" orientation="horizontal"/>
        </Stack>
        <Stack pt="20px" flex={1} spacing={1} overflow="hidden">
          <Stack spacing={3} overflow="auto" className="scrollable" py="20px" pr="10px">
            <Stack mr="-5px">
              <Stack spacing={3} pr="5px">
                {/*<AsyncMultiSelectWithSearchComponent*/}
                {/*  labelWidth={Sizes.drawerInputLabelWidth}*/}
                {/*  label={t('invoices.invoicesValidation.details.filters.client')}*/}
                {/*  getOptions={jobsInvoiceQuery.invoicesClients$}*/}
                {/*  handleChange={updateFilter('clients')}*/}
                {/*  values={newFilters.clients ?? []}/>*/}
                {/*<AsyncMultiSelectWithSearchComponent*/}
                {/*  labelWidth={Sizes.drawerInputLabelWidth}*/}
                {/*  label={t('invoices.invoicesValidation.details.filters.clientUnit')}*/}
                {/*  getOptions={jobsInvoiceQuery.invoicesClientUnits$}*/}
                {/*  handleChange={updateFilter('clientUnits')}*/}
                {/*  values={newFilters.clientUnits ?? []}/>*/}
                <AsyncMultiSelectWithSearchComponent
                  labelWidth={Sizes.drawerInputLabelWidth}
                  label={t('invoices.invoicesValidation.details.filters.clientTypology')}
                  getOptions={jobsInvoiceQuery.invoicesClientKind$}
                  handleChange={updateFilter('clientTypologies')}
                  values={newFilters.clientTypologies ?? []}/>
                <NumberTextFieldComponent
                  labelWidth={Sizes.drawerInputLabelWidth}
                  label={t('invoices.invoicesValidation.details.filters.minPrice')}
                  pattern={new RegExp(/^(\d*|\d+)[,.]?\d*$/)}
                  handleChange={updateFilter('minPrice')}
                  value={newFilters.minPrice}/>
                <NumberTextFieldComponent
                  labelWidth={Sizes.drawerInputLabelWidth}
                  label={t('invoices.invoicesValidation.details.filters.maxPrice')}
                  pattern={new RegExp(/^(\d*|\d+)[,.]?\d*$/)}
                  handleChange={updateFilter('maxPrice')}
                  value={newFilters.maxPrice}/>
              </Stack>
            </Stack>
          </Stack>
        </Stack>
        <Box alignSelf="flex-end" justifySelf="flex-end" my="20px" mr="10px">
          <Button
            variant="contained"
            color="primary"
            disabled={JSON.stringify(filters) === JSON.stringify(newFilters)}
            onClick={() => handleSave(newFilters)}>
            {t('global.modify')}
          </Button>
        </Box>
      </Stack>
    </Drawer>
  );
};

export default FiltersDrawer;
